import { type RefSelectProps, Select } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { STATUSES } from '@/constants/common/message.constants'
import { DUE_DATE_TYPE, DUE_DATE_TYPE_LABEL } from '@/libs/api/types'
import { type DueDateType } from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

type Props = SingleOrMultipleSelectProps<DueDateType, DueDateTypeOption>

type DueDateTypeOption = { label: string; value: DueDateType }

const options: DueDateTypeOption[] = Object.values(DUE_DATE_TYPE).map(
  (type) => ({
    label: DUE_DATE_TYPE_LABEL[type],
    value: type
  })
)

/**
 * 銀行口座種別を選択するSelect
 */
export const DueDateTypeSelect = forwardRef(
  (
    {
      className,
      placeholder = STATUSES.UNSELECTED,
      value,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const handleChange = useSelectOnChangeHandler({ mode, onChange })
    return (
      <Select
        ref={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        className={clsx(['min-w-[140px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
